import { BreadcrumbListJsonLdScriptTag } from '@findy-code/yuffie/shared/json-ld';
import { Breadcrumbs } from '@findy-code/yuffie/ui/breadcrumbs';

export const CompanyDetailBreadcrumbs = ({
  breadcrumbs,
}: {
  breadcrumbs: {
    name: string;
    link: string;
    active: boolean;
  }[];
}) => {
  return (
    <>
      <Breadcrumbs items={breadcrumbs} />
      <BreadcrumbListJsonLdScriptTag
        items={breadcrumbs.map(({ name, link }) => ({ name, link }))}
      />
    </>
  );
};
